import { signature } from './signature';

const plugins = {
  signature,
};

export default plugins;
